import { put, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  changeGameStatusAction,
  startDrawSuccessAction,
  changeGameStateAction,
  drawTimeStartedAction,
  changeTimeLeftAction,
  startIncrementTimeLeftAction,
} from 'data/reducers';
import { DrawStartedResponse, Notifications, TableStates } from 'types';
import { gameStatus } from 'constants/common';
import { getGameData } from 'core/selectors';
import { GameType } from 'types/tables';

export function* drawStarted({ type: notificationType, data: result }: DrawStartedResponse) {
  try {
    if (notificationType === Notifications.DRAW_STARTED) {
      const { drawStartedAt } = result;
      const { game_type } = yield select(getGameData);

      yield put(changeGameStateAction({ tableState: TableStates.DrawStarted }));
      if (game_type === GameType.ROULETTE) {
        yield put(changeGameStatusAction({ status: gameStatus.SpinInProgress }));
      } else yield put(changeGameStatusAction({ status: gameStatus.StartedDraw }));
      yield put(changeTimeLeftAction({ timerLeft: 0 }));
      yield put(drawTimeStartedAction({ drawStartedAt }));
      yield put(startIncrementTimeLeftAction());
      yield put(startDrawSuccessAction());
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
